// extracted by mini-css-extract-plugin
export default {"stat":"DataTag_stat__JIFvD","percentage":"DataTag_percentage__bX5QS","tag":"DataTag_tag__ue-Yd"};